module.exports = __webpack_public_path__ + "static/media/loading.d521bb69.webp";